/**
 * Navigation Service Enums
 * Contains all enum definitions for navigation functionality
 */

/**
 * Navigation error types for better error handling
 */
export enum NavigationErrorType {
  STEP_SAVE_FAILED = "STEP_SAVE_FAILED",
  INVALID_STEP = "INVALID_STEP",
  NAVIGATION_FAILED = "NAVIGATION_FAILED",
  FORM_SUBMISSION_FAILED = "FORM_SUBMISSION_FAILED",
}
